var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('bpmButton',{staticClass:"button",class:{'button_gradient' : _vm.isGradient}},[_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.nameButton))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }